import {
  GetMyOrderPreferencesSlimQuery,
  GetMyOrderPreferencesSlimQueryVariables
} from '@data/__generated__/types.main'
import isServerSide from '@helpers/misc/isServerSide'
import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

export const getMyOrderPreferencesSlimQuery = gql`
  query getMyOrderPreferencesSlim($websiteId: ID) {
    preferences: userPreferences(websiteId: $websiteId) {
      _id
      menuId
      storeId
      deliverAt
      deliveryType
      tableName
      time
      shouldHidePrice
    }
  }
`

export const useMyOrderPreferencesSlim = (
  websiteId?: string,
  opts: {partial?: boolean} = {partial: true}
) => {
  const savedWebsiteId = useWebsiteId()
  websiteId = websiteId ?? savedWebsiteId

  return useApolloQuery<GetMyOrderPreferencesSlimQuery, GetMyOrderPreferencesSlimQueryVariables>({
    query: getMyOrderPreferencesSlimQuery,
    variables: {websiteId},
    omit: isServerSide() || !websiteId,
    fetchPolicy: 'cache-first',
    partial: opts.partial
  })
}
